

import { ISP_Room, QUALITY } from './types'
import { IoLeafSharp } from 'react-icons/io5'
import { themedUseStyletron } from '../../../theme/customTheme';

export function RoomQualitySmall(props: ISP_Room) {
    const [css, theme] = themedUseStyletron();

    var color = theme.colors.positive;
    if ( props.humidityQuality === QUALITY.Bad || props.temperatureQuality === QUALITY.Bad )
        color = theme.colors.negative500;
    else if (props.humidityQuality === QUALITY.Sufficient || props.temperatureQuality === QUALITY.Sufficient  )
        color = theme.colors.warning500;

    return (
        <>
            <IoLeafSharp opacity={'0.5'} size='1.0em' color={color}/>
        </>
    );

    
}






